import type React from 'react';
import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';

import type { ElementSize } from '../../@types/types';

import { ELEMENT_SIZES } from './shared';

const classes = cva(
  [
    'w-full',
    'appearance-none',
    'rounded-md',
    'border',
    'border-info-300',
    'px-3',
    'py-2',
    'text-sm',
    'text-info-700',
    'shadow-xs',
    'focus:outline-primary-500',
  ],
  {
    variants: {
      isIncomplete: { true: 'field-incomplete' },
      isDisabled: { true: 'focus:outline-none' },
      isReadOnly: { true: 'focus:outline-none' },
      size: ELEMENT_SIZES,
    },
  },
);

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  errors?: string | string[];
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  placeholderText?: string;
  size?: ElementSize;
  isIncomplete?: boolean;
  dataTestId?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, id, isIncomplete, isDisabled, isReadOnly, isRequired, name, placeholderText, size = 'md', ...props },
  ref,
) {
  return (
    <input
      className={classes({
        isDisabled,
        isIncomplete,
        isReadOnly,
        size,
        className,
      })}
      disabled={isDisabled}
      id={id ?? name}
      name={name}
      placeholder={placeholderText}
      readOnly={isReadOnly}
      ref={ref}
      required={isRequired}
      {...props}
    />
  );
});

export default Input;
